import { makeAutoObservable } from 'mobx'
import { type ContactsDetailsStore } from 'widgets/ContactsDetails'
import { EnumSyncType } from 'widgets/ContactsDetails/store/types'

type IContactsTagsFormStoreConfig = {
  onSync?: (type: EnumSyncType.tags) => void
}

export class ContactsTagsFormStore {
  private _config: IContactsTagsFormStoreConfig | null = null

  constructor(private _contactsDetailsStore: ContactsDetailsStore) {
    makeAutoObservable(this)
  }

  setConfig = (config: IContactsTagsFormStoreConfig) => {
    this._config = {
      ...this._config,
      ...config,
    }
  }

  onSync = () => {
    this._config?.onSync?.(EnumSyncType.tags)
  }

  get selectedContact() {
    return this._contactsDetailsStore.selectedContact
  }
}
